/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit'
// utils
import { axiosInstance } from '../../utils/axiosInstance'
import axios from 'axios'
import { useSession, signIn, signOut, setSession } from 'next-auth/react'

const url = process.env.BACKEND_URL
const rsl_url = process.env.RSL_BACKEND_URL
const anonKey = process.env.NEXT_PUBLIC_ANON_KEY;
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  userDetail: undefined,
  socialSignupResponse: undefined,
  checkOrderStatusRes: undefined,
  accessTocken: undefined,
  paymentDetails: undefined,
  userData: undefined,
  updateDetail: undefined,
  updateProfileOtpVerifyRes: undefined,
  configData: undefined
}

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
      state.error = null
      state.updateDetail = undefined
      state.updateProfileOtpVerifyRes = undefined
      state.socialSignupResponse = undefined
      state.checkOrderStatusRes = undefined
      state.paymentDetails = undefined
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    getProfileSuccess(state, action) {
      state.isLoading = false
      state.userDetail = action.payload
    },

    updateProfileSuccess(state, action) {
      state.isLoading = false
      state.updateDetail = action.payload
    },
    updateProfileVerifyOtpSuccess(state, action) {
      state.isLoading = false
      state.updateProfileOtpVerifyRes = action.payload
    },

    getSocialSignupSuccess(state, action) {
      state.isLoading = false
      state.socialSignupResponse = action.payload
    },
    getCheckOrderStatusSuccess(state, action) {
      state.isLoading = false
      state.checkOrderStatusRes = action.payload
    },
    getVerifyTelrPaymentSuccess(state, action) {
      state.isLoading = false
      state.verifyTelrPaymentRes = action.payload
    },
    getAccessTokenSuccess(state, action) {
      state.isLoading = false
      state.accessTocken = action.payload
    },
    getPaymentDetailsSuccess(state, action) {
      state.isLoading = false
      state.paymentDetails = action.payload
    },
    getUserDataSuccess(state, action) {
      state.isLoading = false
      state.userData = action.payload
    },
    clearUserDataSuccess(state, action) {
      state.isLoading = false
      state.userData = undefined
    },
    // SUCCESS RESPONSE
    fetchCoreConfigSuccess(state, action) {
      state.isLoading = false
      state.configData = action.payload
    }
  }
})

// Reducer
export default slice.reducer

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity
} = slice.actions

// ----------------------------------------------------------------------

//USER GET PROFILE

export function getProfile(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.get(
        `${rsl_url}/passenger/profile/${obj?.rslId}`
      )
      // const response = await axiosInstance.post(`${url}/user/getProfile`, obj);

      dispatch(slice.actions.getProfileSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// USER UPDATE PROFILE

export function updateProfile(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.put(
        `${rsl_url}/passenger/updateProfile/${obj?.rslId}`,
        obj
      )
      dispatch(slice.actions.updateProfileSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// USER UPDATE PROFILE EMAIL AND OTP VERIFY

export function updateProfileVerifyOtp(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.post(
        `${rsl_url}/passenger/editProfileVerifyOtp`,
        obj
      )
      dispatch(slice.actions.updateProfileVerifyOtpSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// USER socialSignup

export function socialSignup(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.post(
        `${rsl_url}/passenger/lifestyleSocialSignup`,
        obj
      )
      dispatch(slice.actions.getSocialSignupSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

//USER checkOrderStatus

export function checkOrderStatus(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.post(
        `${url}/booking/checkOrderStatus`,
        obj
      )
      dispatch(slice.actions.getCheckOrderStatusSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function verifyTelrPayment(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.post(
        `${rsl_url}/trip/verifyTelrPayment`,
        obj
      )
      dispatch(slice.actions.getVerifyTelrPaymentSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function getAccessToken(obj) {
  const axiosConfig = {
    headers: {
      "Authorization": `Bearer ${anonKey}` || "-",   // send "-" or handle missing case
    },
  }
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      let refreshToken = sessionStorage.getItem("refreshToken");
      const response = await axiosInstance.post(
        `${rsl_url}/passenger/v1/passenger/getAccessToken`,
        { refreshToken },
        axiosConfig
      )
      dispatch(slice.actions.getAccessTokenSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function getPaymentDetails(obj) {
  const axiosConfig = {
    headers: {
      Authorization: `0003ec7c2a11e8ec20d622b83f95831a` // Assuming you're using a Bearer token
    }
  }
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/taxi/getPaymentDetails`,
        obj
      )
      dispatch(slice.actions.getPaymentDetailsSuccess(response.data))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function clearPaymentDetails() {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.getPaymentDetailsSuccess(null))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// get user data

export function getUserData(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.getUserDataSuccess(obj))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// clearuser data

export function clearUserData(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.clearUserDataSuccess(obj))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// clearuserdetail

export function clearUserDetail(obj) {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.getProfileSuccess(undefined))
    } catch (error) {
      dispatch(slice.actions.hasError(error))
    }
  }
}

// session clear

export function fetchCoreConfig() {
  return async dispatch => {
    dispatch(slice.actions.startLoading())
    try {
      const response = await axios.get(
        `${process.env.BACKEND_URL}/taxi/getCoreConfigWeb`,
        {
          headers: {
            "Authorization": `Bearer ${anonKey}` || "-",   // send "-" or handle missing case
          },
        }

      )

      const apiVersion = response?.data?.responseData?.version
      const webServiceList = response?.data?.responseData?.webServiceList
      const storedVersion = localStorage.getItem('app_version')
      localStorage.setItem('webServiceList', JSON.stringify(webServiceList))

      if (!storedVersion || storedVersion !== apiVersion) {
        // Clear Local Storage
        localStorage.clear()

        // Clear Session Storage
        sessionStorage.clear()
        signOut({ redirect: false })

        // Clear Cookies
        document.cookie.split(';').forEach(cookie => {
          document.cookie = cookie
            .replace(/^ +/, '')
            .replace(
              /=.*/,
              '=;expires=' + new Date(0).toUTCString() + ';path=/'
            )
        })

        // Store the new version
        localStorage.setItem('app_version', apiVersion)

        // Delay dispatch for UX purposes
        setTimeout(() => {
          dispatch(slice.actions.fetchCoreConfigSuccess(true))
        }, 2000)
      } else {
        dispatch(slice.actions.fetchCoreConfigSuccess(true))
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error.message))
    }
  }
}
